import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { convertDataChart, convertDataVSIC } from '../helper'
import { getRiskDistribution, getVSIC } from './thunk'

const initialState = {
  loading: {
    getVSIC: true,
    riskDistribution: true,
  },
  dataVSIC: [],
  dataVSICFullLevel: [],
  activeVSIC: {
    id: 0,
  },
  dataChart: [],
  totalCompany: 0,
  idVSICKey: 0,
}

const slice = createSlice({
  name: 'dashboard/creditRisk',
  initialState: initialState,
  reducers: {
    changeActiveVSIC: (state, action) => {
      state.activeVSIC = action.payload
    },
  },
  extraReducers: (builder) => {
    //getVSIC
    builder.addCase(getVSIC.pending, (state) => {
      state.loading.getVSIC = true
    })
    builder.addCase(getVSIC.fulfilled, (state, action) => {
      state.dataVSIC = convertDataVSIC(
        action.payload.filter((item) => item.level < 4) || [],
      )
      state.dataVSICFullLevel = convertDataVSIC(action.payload || [])
      state.loading.getVSIC = false
    })
    builder.addCase(getVSIC.rejected, (state, action) => {
      state.dataVSIC = initialState.dataVSIC
      state.loading.getVSIC = action.payload.loading
    })
    //getRiskDistribution
    builder.addCase(getRiskDistribution.pending, (state) => {
      state.loading.riskDistribution = true
    })
    builder.addCase(getRiskDistribution.fulfilled, (state, action) => {
      state.idVSICKey = action.payload?.metaData
      state.dataChart = convertDataChart(action.payload?.data || [])
      state.totalCompany = action.payload ? action.payload?.data[0]?.total : 0
      state.loading.riskDistribution = false
    })
    builder.addCase(getRiskDistribution.rejected, (state, action) => {
      state.dataChart = initialState.dataChart
      state.totalCompany = initialState.totalCompany
      state.loading.riskDistribution = action.payload.loading
    })
  },
})

//loading
export const getLoadingCreditRisk = (type) => (state) =>
  state[slice.name].loading[type]
//VSIC
export const selectVSICFullLevel = (state) =>
  state[slice.name].dataVSICFullLevel
export const selectVSIC = (state) => state[slice.name].dataVSIC
export const selectActiveVSIC = (state) => state[slice.name].activeVSIC
//total company
export const selectTotalCompany = (state) => state[slice.name].totalCompany
//risk distribution
export const selectDataRiskDistribution = (state) => state[slice.name].dataChart
//id key VSIC
export const selectIdKeyVSIC = (state) => state[slice.name].idVSICKey

export const { changeActiveVSIC } = slice.actions

register(slice.name, slice.reducer)
